var _path, _path2, _path3, _ellipse, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKimWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 34,
    viewBox: "0 0 117 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3504 22.5668C25.6048 27.0789 22.8269 31.7356 20.7811 33.5L6.99891 22.3933C1.9979 18.133 4.34272 13.5879 6.60799 11.5252L20.3504 22.5668Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3504 10.9332C25.6048 6.42107 22.8269 1.76437 20.7811 3.17908e-05L6.99891 11.1067C1.8306 15.4452 4.41475 20.1309 6.56822 22.0398L20.3504 10.9332Z",
    fill: "#FABF01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3051 8.6055C71.4269 8.6055 73.1469 10.3255 73.1469 12.4472V29.6582C73.1469 31.78 71.4269 33.5 69.3051 33.5C67.1834 33.5 65.4634 31.78 65.4634 29.6583V12.4472C65.4634 10.3255 67.1834 8.6055 69.3051 8.6055Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.3564,
    cy: 3.68807,
    rx: 3.83008,
    ry: 3.68807,
    fill: "#FABF01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.064 33.5V8.62209H85.0521V13.0114H85.3619C85.9127 11.5537 86.8307 10.4037 88.1158 9.56149C89.401 8.71927 90.9386 8.29816 92.7287 8.29816C94.5417 8.29816 96.085 8.72467 97.3587 9.57769C98.6324 10.4199 99.4816 11.5645 99.9061 13.0114H100.182C100.721 11.5861 101.696 10.4469 103.108 9.59389C104.53 8.73007 106.211 8.29816 108.151 8.29816C110.618 8.29816 112.62 9.03781 114.158 10.5171C115.707 11.9856 116.481 14.0695 116.481 16.769V33.5H109.166V18.1295C109.166 16.7474 108.776 15.7108 107.996 15.0197C107.216 14.3287 106.24 13.9832 105.07 13.9832C103.739 13.9832 102.7 14.3827 101.954 15.1817C101.209 15.9699 100.836 17.0119 100.836 18.3076V33.5H93.727V17.9837C93.727 16.7636 93.3541 15.7918 92.6082 15.0683C91.8738 14.3449 90.9042 13.9832 89.6994 13.9832C88.8846 13.9832 88.1503 14.1775 87.4962 14.5662C86.8536 14.9441 86.343 15.4786 85.9643 16.1697C85.5857 16.8499 85.3963 17.649 85.3963 18.5668V33.5H78.064Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2408 26.3363L43.258 18.0544H44.329L52.8275 8.6055H61.2741L49.8565 21.1176H48.1118L43.2408 26.3363ZM36.5732 33.5V0H43.9317V33.5H36.5732ZM53.1557 33.5L45.3481 22.6573L50.2537 17.7789L61.7751 33.5H53.1557Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKimWhite);
export default __webpack_public_path__ + "static/media/kim-white.bec1bb6ee12fa7c798bd1bac7506ae3c.svg";
export { ForwardRef as ReactComponent };